import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Slider from "react-slick";
import BackgroundImage from "../Assets/img/blog/freepik__candid-image-photography-natural-textures-highly-r__73737.jpeg";
import { FaUserAlt } from "react-icons/fa"; // Import the fallback icon

const TestimonialSection = styled.section`
  position: relative;
  padding: 60px 20px;
  text-align: center;
  background: url(${BackgroundImage}) center/cover no-repeat;
  color: white;

  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 43, 122, 0.7);
    z-index: 1;
  }

  h2 {
    font-size: 2rem;
    font-weight: bold;
    margin-bottom: 20px;
    color: #fff;
    position: relative;
    z-index: 2;
  }

  .testimonial-container {
    position: relative;
    max-width: 800px;
    margin: 0 auto;
    z-index: 2;

    .slick-slider {
      .slick-dots {
        bottom: -25px;
        li button:before {
          color: #007bff;
        }

        li.slick-active button:before {
          opacity: 1;
          color: #fff;
        }
      }
    }
  }

  .profile-image {
    position: relative;
    margin: 0 auto 20px;
    width: 120px;
    height: 120px;
    border-radius: 50%;
    overflow: hidden;
    background:rgb(6, 59, 114);
    border: 5px solid #007bff;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 50%;
    }
      

    svg {
      width: 100%;
      height: 100%;
      object-fit: contain;
      color: #007bff; /* Set icon color */
    }

    .initial {
      font-size: 2rem;
      color: #007bff;
      font-weight: bold;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;
      width: 100%;
      background-color: #f0f0f0; /* Background color for fallback */
    }
  }

  .testimonial-card {
    background-color: rgba(0, 123, 255, 0.9);
    color: white;
    padding: 30px 20px;
    border-radius: 10px;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);

    p {
      font-size: 1rem;
      line-height: 1.6;
      margin-bottom: 15px;
    }

    .read-more {
      color: #ff5757;
      cursor: pointer;
      font-weight: bold;
    }

    .client-name {
      font-size: 1.2rem;
      font-weight: bold;
    }

    .client-profession {
      font-size: 0.9rem;
      font-style: italic;
      opacity: 0.8;
    }
  }
`;
const StyledImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;
const SliderWrapper = styled.div`
  .slick-slide {
    padding: 10px;
  }

  .slick-dots li button:before {
    color: rgb(209, 5, 5);
    font-size: 12px;
  }
`;

const Testimonials = () => {
  const [testimonials, setTestimonials] = useState([]);
  const [isLoading, setIsLoading] = useState(true); // To show a loading state

  useEffect(() => {
    const fetchTestimonials = async () => {
      try {
        const response = await fetch(
          "https://pristineacademicconsultancy.com/Admin/testimonial.php"
        );
        const data = await response.json();

        // Check if the response is an array
        if (Array.isArray(data)) {
          setTestimonials(data);
        } else {
          console.error("Error: Testimonials data is not an array");
        }
      } catch (error) {
        console.error("Error fetching testimonials:", error);
      } finally {
        setIsLoading(false); // Hide the loading state after fetching
      }
    };

    fetchTestimonials();
  }, []);

  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 2000,
    slidesToShow: 1,
    autoplay: true,
    autoplaySpeed: 10000,
    slidesToScroll: 1,
    arrows: false,
  };

  const [expandedFeedback, setExpandedFeedback] = useState({});

  const toggleReadMore = (id) => {
    setExpandedFeedback((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  if (isLoading) {
    return <div>Loading testimonials...</div>; // Display a loading message while data is fetched
  }

  return (
    <TestimonialSection>
      <h2>Success Stories from PAC</h2>
      <div className="testimonial-container">
        <SliderWrapper>
          <Slider {...sliderSettings}>
            {testimonials.length > 0 ? (
              testimonials.map(({ id, name, profession, feedback, image }) => (
                <div key={id}>
                  <div className="profile-image">
                  <StyledImage src={image} alt="Image description" onError={(e) => (e.target.style.display = "none")} />
                  {!image && <span style={{ color: "#333" }}>Image not available</span>}
                  </div>
                  <div className="testimonial-card">
                    <p>
                      {feedback.length > 300 && !expandedFeedback[id]
                        ? `${feedback.slice(0, 400)}...`
                        : feedback}
                      {feedback.length > 100 && (
                        <span
                          className="read-more"
                          onClick={() => toggleReadMore(id)}
                        >
                          {expandedFeedback[id] ? " Show Less" : " Read More"}
                        </span>
                      )}
                    </p>
                    <div className="client-name">{name || "Anonymous"}</div>
                    <div className="client-profession">
                      {profession || "Client"}
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div>No testimonials available at the moment.</div> // Fallback if no testimonials
            )}
          </Slider>
        </SliderWrapper>
      </div>
    </TestimonialSection>
  );
};

export default Testimonials;
